export default __webpack_public_path__ + "static/media/No49.a2ffc634.png";